(function () {
  'use strict';
  var shell = document.querySelector('[data-dw-boost-shell]');
  var fallback = shell && shell.querySelector('[data-dw-collection-fallback]');
  var mount = shell && shell.querySelector('[data-dw-boost-results]');
  if (!fallback || !mount || shell.dwFallbackAttached) return;
  shell.dwFallbackAttached = true;
  var nativeBrowsing = new URLSearchParams(window.location.search).has('dw_native');
  function retainNative() {
    nativeBrowsing = true;
    shell.setAttribute('data-dw-native-browsing', '');
    fallback.hidden = false;
  }
  function update() {
    if (nativeBrowsing) return retainNative();
    var output = mount.querySelector('.boost-sd__product-item a[href*="/products/"], .boost-sd__no-search-result-page, .boost-sd__product-list-pagination-in-collection-search-empty-message');
    fallback.hidden = Boolean(output);
    if (output) mount.hidden = false;
  }
  fallback.addEventListener('focusin', retainNative);
  fallback.addEventListener('pointerdown', retainNative);
  var observer = new MutationObserver(update);
  observer.observe(mount, { childList: true, subtree: true });
  window.addEventListener('dw:boost-client-ready', update);
  window.addEventListener('pagehide', function () {
    observer.disconnect();
    window.removeEventListener('dw:boost-client-ready', update);
  }, { once: true });
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      observer.observe(mount, { childList: true, subtree: true });
      window.addEventListener('dw:boost-client-ready', update);
      update();
    }
  });
  update();
}());
